const { indexBy, prop, pluck } = require('ramda')

const significantDateTypes = [
  { value: 'spouse-partner-passing', label: 'Anniversary of Spouse/Partner Passing' },
  { value: 'child-sibling-passing', label: 'Anniversary of Child/Sibling Passing' },
  { value: 'other-significant-loss', label: 'Anniversary of Other Significant Loss' },
  { value: 'other', label: 'Other' },
]

const significantDateTypeLabels = indexBy(prop('value'), significantDateTypes)
const significantDateTypeValues = pluck('value', significantDateTypes)

module.exports = { significantDateTypes, significantDateTypeLabels, significantDateTypeValues }
